
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardStep2Controller from './project-donation-wizard.step2.controller';
import ProjectDonationWizardStep2Template from './project-donation-wizard.step2.html';

export default class ProjectDonationWizardStep2Component {
		constructor() {
				this.templateUrl = ProjectDonationWizardStep2Template;
				this.controller = ProjectDonationWizardStep2Controller;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					donation: '<',
					stripeAccount: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step2/project-donation-wizard.step2.component.js